import { DISCLAIMER_TEXT } from "@/lib/pdf";

export default function Disclaimer({ testId = "disclaimer-block", compact = false }) {
  return (
    <div
      className={`rounded-md border border-[#0A1128]/10 bg-[#F9FAFB] ${
        compact ? "p-4" : "p-6"
      }`}
      data-testid={testId}
    >
      <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gold">
        Disclaimer
      </div>
      <p className="mt-2 text-xs leading-relaxed text-[#4A5568] sm:text-sm">
        {DISCLAIMER_TEXT}
      </p>
    </div>
  );
}
